<template>
  <div>
    <div :class="{ page_header: inline }">
      <span class="page_title" style="">{{
        $t("statistics.doorOpeningAndClosingDetails")
      }}</span>

      <quickQuery
        :speedShow="true"
        @handleQuery="handleQuery"
        @quickQuery="quickQuery"
        @download="download"
        :downloading="downloading"
        style="flex: 1; text-align: right"
      />
    </div>
    <div class="page_container">
      <el-table
        :size="size"
        v-loading="loading"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column
          :label="$t('public.OrderIndex')"
          prop="id"
          align="center"
          width="105"
        ></el-table-column>
        <el-table-column
          :label="$t('vehicle.carNo')"
          prop="carNo"
          align="center"
        ></el-table-column>
        <el-table-column :label="$t('statistics.frontDoor')" align="center">
          <template slot-scope="scope">
            <!-- {{doorTypeLanguages(scope.row)}} -->
            <el-tag
              v-if="scope.row.isOpen.indexOf('前门') > -1"
              size="mini"
              type="success"
              effect="dark"
              >{{ $t("statistics.opened_door") }}</el-tag
            >
            <!-- <div v-if="scope.row.isOpen.indexOf('前门') > -1" style="height:5px;width:5px;color:green" > qian</div> -->
            <el-tag v-else size="mini" type="danger" effect="dark">{{
              $t("statistics.close_door")
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('statistics.middleDoor')" align="center">
          <!--'$t("statistics.isOpen")' 多加一列进行前中门查看 -->
          <template slot-scope="scope">
            <!-- {{doorTypeLanguages(scope.row)}} -->
            <el-tag
              v-if="scope.row.isOpen.indexOf('中门') > -1"
              size="mini"
              type="success"
              effect="dark"
              >{{ $t("statistics.opened_door") }}</el-tag
            >
            <el-tag v-else size="mini" type="danger" effect="dark">{{
              $t("statistics.close_door")
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('statistics.openTime')"
          prop="openTime"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('statistics.speed')"
          prop="speed"
          align="center"
        ></el-table-column>
        <!-- <el-table-column label="仪表里程(km)" prop="gaugeMileage" align="center"></el-table-column>
        <el-table-column label="位置" prop="location" align="center"></el-table-column>
        <el-table-column label="地图位置" prop="mapLocation" align="center">
          <template slot-scope="scope">
            <div class="iconfont"  @click="mapLacation(scope.row)"><i class="iconfont icon-icon_operat_map"></i></div>
          </template>
        </el-table-column> -->
        <!-- <i class="iconfont icon-icon_operat7_map" style="color:#0F1A3A " @click="mapLacation(scope.row)"></i>  -->
      </el-table>
    </div>
    <div
      style="text-align: right; margin-top: 10px"
      class="pagination"
      v-show="total > 0"
    >
      <!--  -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="form.pageSize"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- <div class="dialog">
      <el-dialog title="地图位置" :visible.sync="mapShow">
        <div style="text-align:center">
          <KingLongMap ref="klmap_door" style="width:100%;height: 350px;" />
        </div>
        
      </el-dialog>
    </div> -->
  </div>
</template>

<script>
import KingLongMap from "@/components/KingLongMap";
import quickQuery from "../components/generalOrQuickQuery.vue";
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
export default {
  name: "doorSearch",
 
  components: {
    quickQuery,
    KingLongMap,
  },
  data() {
    return {
      downloading:false,
      inline: true,
      loading: false,
      lon: "",
      lat: "",
      total: 0,
      currentPage: 1,
      // nowData:new Date(),
      dataList: [],
      mapShow: false,
      showBtn: undefined, //按钮默认选中：今天
      searchTime: [
        new Date(),
        new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
      ], //
      form: {
        // speed:0,
        // beginDate:"",
        // endDate:"",
        // pageNum:1,
        // pageSize:10,
      },
      vehicles: "",
      marker: undefined,
      autoWidth: true,
      LanguageId:1,
    };
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    ...mapState({
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
    }),
  },
  watch: {},
  methods: {
    doorTypeLanguages(row) {
      // console.log(row);
      switch (row.isOpen) {
        case "前门":
          console.log("前门");
          return this.$t("statistics.frontDoor");
          break;
        case "中门":
          console.log("中门");
          return this.$t("statistics.middleDoor");
          break;
        case "前门/中门":
          return this.$t("statistics.front_middleDoor");
          break;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    mapLacation(row) {
      // var _this = this;
      this.mapShow = true;
      this.lon = row.lon;
      this.lat = row.lat;
      this.$nextTick(function () {
        if (this.$refs.map) {
          this.$refs.map.clearMarkers();
          this.$refs.map.addMarker(
            "v_1011",
            "", //row.CarNo,
            this.lon,
            this.lat,
            "assets/svgs/icon_loc_selected_270.svg"
          );
          this.$refs.map.setCenter(this.lon, this.lat);
        }
      });
    },
    getSelectedVehicles() {
      this.vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles =
            this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    handleQuery(val) {
      this.form = val;
      // console.log(this.$store.getters.operator.OperatorId);
      this.vehicles = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
    },
    quickQuery(val) {
      this.form = val;
      this.vehicles = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$api
        .doorsInfo({
          optID: this.$store.getters.operator.OperatorId, //6787,
          beginDate: this.form.beginDate,
          endDate: this.form.endDate,
          Vehicles: this.vehicles, //"94472,97509"
          speed: this.form.speed,
          PageNo: this.currentPage,
          PageSize: 10,
          IsExport: 0, // 0是查询 1是下载
          Language: this.LanguageId,
        })
        .then((res) => {
          if (res && res.code == 200) {
            // console.log("=-------");
            this.loading = false;
            this.dataList = res.data;
            this.total = res.recordsTotal;
            if (this.total == 0) {
              this.$message.info(this.$t("statistics.noData"));
            }
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    download() {
      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api
        .doorsInfoDownload({
          optID: this.$store.getters.operator.OperatorId, //6787,
          beginDate: this.form.beginDate,
          endDate: this.form.endDate,
          Vehicles: this.vehicles, //"94472,97509"
          speed: this.form.speed,
          IsExport: 1, // 0是查询 1是下载
          Language: this.LanguageId,
        })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t("statistics.doorOpeningAndClosingDetails") + ' ' + that.$t('public.download') + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },

    format(datetime, format) {
      var o = {
        "M+": datetime.getMonth() + 1, //month
        "d+": datetime.getDate(), //day
        "h+": datetime.getHours(), //hour
        "m+": datetime.getMinutes(), //minute
        "s+": datetime.getSeconds(), //second
        "q+": Math.floor((datetime.getMonth() + 3) / 3), //quarter
        S: datetime.getMilliseconds(), //millisecond
      };

      // /(y+)/.test("yyyy-MM-dd");
      // console.log(/(y+)/.exec("yy-MM-dd")[0],111);
      // console.log(RegExp.$1,222);
      // let format = "yyyy-MM-dd";
      // format = format.replace(RegExp.$1,(this.searchTime[0].getFullYear() + "").substring(4 - RegExp.$1.length));
      // console.log((this.searchTime[0].getFullYear() + "").substring(4 - RegExp.$1.length),333,format);

      if (/(y+)/.test(format)) {
        format = format.replace(
          /(y+)/.exec(format)[0],
          (datetime.getFullYear() + "").substring(
            4 - /(y+)/.exec(format)[0].length
          )
        );
      }

      for (var k in o) {
        // console.log(o[k]);
        if (new RegExp("(" + k + ")").test(format)) {
          let item = eval("/(" + k + ")/.exec(format)[0]");
          format = format.replace(
            item,
            item.length == 1
              ? o[k]
              : ("00" + o[k]).substring(("" + o[k]).length)
          );
          // console.log(format,"0.0");
        }
      }
      return format;
    },
  },
  mounted() {
    this.LanguageId = language(this.$store.getters.locale)
  },
};
</script>
<style scoped>
</style>

<style lang="scss"  scoped>
.el-tag--mini {
  height: 17px;
  line-height: 17px;
  padding: 0 3px;
}
.pagination   {
  ::v-deep .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background-color: transparent !important;
  }
}

.dialog {
  ::v-deep .el-dialog__header {
    background: #e8f0ff;
    text-align: center;
  }
}

.iconfont {
  color: #0f1a3a;
  :hover {
    color: #2a7aff;
  }
}

.input-number  {
  ::v-deep .el-input {
    position: relative;
    &::before {
      content: "km/h";
      position: absolute;
      top: 0;
      right: 25px;
      height: 32px;
      line-height: 35px;
      color: #0f1a3a;
      font-size: 12px;
    }
  }
  ::v-deep .el-input-number {
    &__increase,
    &__decrease {
      background-color: transparent;
      border: 0 !important;
      width: 25px;
    }
    .el-icon-arrow-up::before {
      content: "";
    }
    .el-icon-arrow-down::before {
      content: "";
    }
    &.is-controls-right .el-input-number__decrease [class*="el-icon"],
    &.is-controls-right .el-input-number__increase [class*="el-icon"] {
      transform: scale(1.1);
    }
  }
}

// .selectIcon{
//   .el-icon-arrow-up:before {
//     content: "\e78f";
//   }
//   .el-select .el-input .el-select__caret{
//     color: #0F1A3A;
//   }
// }

</style>